// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  enableSocialEvents: false,
  comingSoon: true,
  environment: 'local',
  communicationEndPoint: 'https://fccs.communication.azure.com',
  serviceURL: 'https://familycentraldevapi.azurewebsites.net',
  //serviceURL: 'https://localhost:44316',
  cluApiURL: 'https://cluapidev.farmfuture.io',
  blobURL: 'https://familycentralb2cdev.blob.core.windows.net',
  cdnURL: 'https://familycentral.azureedge.net',
  auth: {
    domain: 'dev-familycentral.us.auth0.com',
    client_id: 'TEMTqqbsdZfFO4imgjN72RUSzLU1OQpc',
    audience: 'https://familycentraldevapi.azurewebsites.net/',
  },
  appInsights: {
    instrumentationKey: 'ab9a27d9-8b93-409b-b016-027a7d310654',
  },
  gmapsKey: 'AIzaSyB_5WVlMJ7G4YVSYRJoD4tJYWgoeRP83yg',
  authorizeIFrameUrl: 'https://test.authorize.net/payment/payment',
  brevoURL: 'https://familycentral.azurewebsites.net',
  synfusionKey:
    'Ngo9BigBOggjHTQxAR8/V1NAaF1cVGhIfEx1RHxQdld5ZFRHallYTnNWUj0eQnxTdEFjXX1ccHRUQmBVUEV/Ww==',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
